import { ESTADOS_TICKET } from "./constants";

export const getEstadoInfo = estado => {
  switch (estado) {
    case ESTADOS_TICKET.recibido.value:
      return ESTADOS_TICKET.recibido;
    case ESTADOS_TICKET.enEmpaque.value:
      return ESTADOS_TICKET.enEmpaque;
    case ESTADOS_TICKET.listoParaEntregar.value:
      return ESTADOS_TICKET.listoParaEntregar;
    case ESTADOS_TICKET.enEntrega.value:
      return ESTADOS_TICKET.enEntrega;
    case ESTADOS_TICKET.entregado.value:
      return ESTADOS_TICKET.entregado;
    case ESTADOS_TICKET.pedidoConIncidente.value:
      return ESTADOS_TICKET.pedidoConIncidente;
    case ESTADOS_TICKET.abandonado.value:
      return ESTADOS_TICKET.abandonado;
    case ESTADOS_TICKET.cancelado.value:
      return ESTADOS_TICKET.cancelado;
    default:
      return { value: null, label: "", icon: () => null };
  }
};
